export default {

    // Amazon Cognito Region
    region: import.meta.env.VITE_AWS_REGION,

    // Amazon Cognito User Pool ID
    userPoolId: import.meta.env.VITE_AWS_COGNITO_POOL_ID,

    // Amazon Cognito Web Client ID (26-char alphanumeric string)
    userPoolWebClientId: import.meta.env.VITE_AWS_COGNITO_WEB_CLIENT_ID,

    // Enforce user authentication prior to accessing AWS resources or not
    mandatorySignIn: true,

    // Hosted UI configuration
    oauth: {
        domain: import.meta.env.VITE_OAUTH_DOMAIN,
        scope: ['email', 'aws.cognito.signin.user.admin', 'openid', 'profile'],
        redirectSignIn: `${window.location.protocol}//${window.location.host}/auth`,
        redirectSignOut: `${window.location.protocol}//${window.location.host}/signout`,
        responseType: 'code'
    }
};